import React, { use } from 'react';
import { ExtendedCompleteRiskFieldsEvaluationHistory } from '@pages-clean/risk-assessment/risk-log/constants';
import { RiskLogContext } from '@pages-clean/risk-assessment/risk-log/interfaces/context';
import EvaluationsChart from '@pages-clean/risk-assessment/risk-log/sections/childArea/evaluation/evaluation.chart';
import EvaluationsGrid from '@pages-clean/risk-assessment/risk-log/sections/childArea/evaluation/evaluation.grid';
import { RiskEvaluationScoreTrendType } from 'types/graphql-global-types';
import { useTranslation } from '@hooks/index';
// eslint-disable-next-line max-len
import { CompleteRiskFields_Risk_evaluationHistory_RiskEvaluation as CompleteRiskFields_evaluationHistory } from '@queries/generated/fragments.generated';

const EvaluationArea = () => {
    const { current } = use(RiskLogContext);
    const riskEvaluations = current.selectionState.selectedItem?.evaluationHistory;
    const { t } = useTranslation('ram', { keyPrefix: 'riskLog' });

    const formatEvaluationHistoryData = (items: CompleteRiskFields_evaluationHistory[]) => {
        const sortedItems = items.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
        return sortedItems.map((item, index) => {
            const { score, movement } = item;
            const isLastItem = index !== sortedItems.length - 1;
            const prevItemScore = isLastItem ? sortedItems[index + 1].score : null;
            const prevItemColor = isLastItem ? sortedItems[index + 1].colour : null;
            const sortMovement =
                movement === RiskEvaluationScoreTrendType.RISING
                    ? 3
                    : movement === RiskEvaluationScoreTrendType.FALLING
                      ? 1
                      : 2;
            return {
                ...item,
                score: {
                    score: score!,
                    colour: item.colour,
                    movement: movement && movement !== 'NO_MOVEMENT' ? t(`grids.risks.movement.${movement}`) : '',
                    sortMovement,
                    prevScore: prevItemScore,
                    prevColour: prevItemColor,
                },
                createdBy: item.createdBy ? `${item.createdBy.firstName} ${item.createdBy.lastName}` : '',
                updatedBy: item.updatedBy ? `${item.updatedBy.firstName} ${item.updatedBy.lastName}` : '',
                evaluationModelName: item.evaluationModel?.name,
            };
        });
    };

    const flattenedEvaluations: ExtendedCompleteRiskFieldsEvaluationHistory[] = riskEvaluations
        ? formatEvaluationHistoryData(riskEvaluations.filter((e) => e !== null))
        : [];

    return (
        <>
            {riskEvaluations && riskEvaluations.length > 1 && (
                <div style={{ height: '40%' }}>
                    <EvaluationsChart evaluations={[...flattenedEvaluations]} />
                </div>
            )}
            <div
                className="remove-card-padding"
                style={{ height: riskEvaluations && riskEvaluations.length > 1 ? '60%' : '100%' }}
            >
                <EvaluationsGrid evaluations={flattenedEvaluations} />
            </div>
        </>
    );
};

export default EvaluationArea;
